{
  "GenericFooter_ServerErrorTitle": "Errori di convalida",
  "GenericFooter_ValidationWarning": "Assicurarsi che tutti i campi siano compilati correttamente",
  "GenericFooter_ButtonHelpLabel": "Aiuto?",
  "GenericFooter_ButtonSubmitLabel": "Risparmiare",
  "GenericFooter_ButtonCancelLabel": "Annullamento",
  "NAME": "GenericFooter"
}